import { Component, Input } from '@angular/core';
import { Action } from 'src/app/models/callContext.model';
import { ActionButtonComponent, IconType } from './action-button.component';


@Component({
    selector: 'app-action-buttons',
    template: `
  <div class="actions">
    @for(action of actions; track $index)
    {
      <app-action-button title="{{action.title}}" [showText]="false" [action]="action">{{action.title}}</app-action-button>
    }
  </div>
  `,
    styles: [
        `

.actions{
    display: flex;
    margin-bottom: 4px;
    gap: 4px;
    flex-wrap: wrap;
}

    `
    ],
    imports: [ActionButtonComponent]
})
export class ActionButtonsComponent{
  @Input() actions!: Action[] | undefined;
  iconType = IconType;
}
